export default __webpack_public_path__ + "static/media/round-boxim3.c322314a.png";